<template>
  <div class="mt-3">
    <div class="mb-3">
      <button class="btn btn-primary" @click="showLookup = true">
        {{ trans("admin.cdr.createFlag") }}
      </button>
    </div>

    <clip-loader v-if="loading" />

    <div class="table-responsive">
      <table class="table table-hover interactive-table">
        <thead class="sortable-table-header">
          <tr>
            <th v-if="showCentreColumn">{{ trans("examination.center") }}</th>
            <th>{{ trans("admin.cdr.type") }}</th>
            <th>{{ trans("admin.cdr.reasonCategory") }}</th>
            <th>{{ trans("admin.cdr.requestedAction") }}</th>
            <th>{{ trans("admin.cdr.status") }}</th>
            <th>{{ trans("admin.cdr.flaggedBy") }}</th>
            <th>{{ trans("admin.cdr.createdAt") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="flag in flags" :key="flag.id" @click="openFlag(flag.id)">
            <td v-if="showCentreColumn">{{ flag.flaggable?.center?.name }}</td>
            <td>{{ flag.flaggable_type_label }}</td>
            <td>{{ flag.reason_label }}</td>
            <td>{{ flag.requested_action_label }}</td>
            <td>
              <span :class="statusClass(flag.status)">
                {{ flag.status_label }}
              </span>
            </td>
            <td>{{ flag.flagged_by?.full_name }}</td>
            <td>{{ flag.created_at_formatted }}</td>
          </tr>
          <tr v-if="!loading && flags.length === 0">
            <td
              :colspan="showCentreColumn ? 7 : 6"
              class="text-center text-muted"
            >
              {{ trans("admin.cdr.noFlags") }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row-fluid float-right">
      <DerPaginate
        v-model="paginate.current_page"
        :page-count="paginate.last_page"
        :show-go="true"
        @change="getFlags"
      />
    </div>

    <CdrFlagsLookupDialog
      :show="showLookup"
      :api-base="apiBase"
      @close="showLookup = false"
      @created="onFlagCreated"
    />
  </div>
</template>

<script>
import ClipLoader from "../Utils/ClipLoader.vue";
import DerPaginate from "../../design-system/DerPaginate.vue";
import CdrFlagsLookupDialog from "./CdrFlagsLookupDialog.vue";
import { statusClass } from "./cdr-flag-status";
import { practitionerHttpService } from "../../app/practitioner-portal/store/practitioner-http-service";

export default {
  components: { ClipLoader, DerPaginate, CdrFlagsLookupDialog },
  props: {
    apiBase: { type: String, required: true },
    detailRoutePath: { type: String, required: true },
    showCentreColumn: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: true,
      flags: [],
      paginate: {
        current_page: 0,
        total: 0,
        last_page: 0,
      },
      showLookup: false,
    };
  },
  created() {
    this.getFlags(1);
  },
  methods: {
    getFlags(page = 1) {
      this.loading = true;
      practitionerHttpService
        .get(this.apiBase + "/flags", { params: { page } })
        .then((res) => {
          this.flags = res.data.data;
          this.paginate = {
            current_page: res.data.meta.current_page,
            total: res.data.meta.total,
            last_page: res.data.meta.last_page,
          };
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.userErrorMessage(error);
        });
    },
    openFlag(id) {
      this.$router.push(this.detailRoutePath + id);
    },
    onFlagCreated() {
      this.showLookup = false;
      this.getFlags(1);
    },
    statusClass,
  },
};
</script>
